<template>
  <v-card class="pb-1">
    <v-form ref="form" v-model="valid" lazy-validation>
    <v-card-title class="px-3 pt-3">
      <h4 class="font-weight-bold">個人情報の修正</h4>
    </v-card-title>
    <v-divider class="my-1 mx-3"></v-divider>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs2 pt-2 mt-1>名前</v-flex>
        <v-flex xs10>
          <v-text-field
            outline
            solo
            required
            label="姓名"
            v-model="agentInfo.name"
            :rules="[rules.required, rules.nameLength]"
            counter="20"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pt-2 mt-1>ID</v-flex>
        <v-flex xs10>
          <v-text-field
            outline
            solo
            label="ID"
            v-model="agentInfo.loginId"
            required
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pt-2 mt-1>メールアドレス</v-flex>
        <v-flex xs10>
          <v-text-field
            outline
            solo
            label="メールアドレス"
            v-model="agentInfo.email"
            :rules="[rules.required, rules.emailRules]"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pt-2 mt-1>連絡先</v-flex>
        <v-flex xs10>
          <v-text-field
            outline
            solo
            label="連絡先"
            v-model="agentInfo.phoneNumber"
            :rules="[rules.required, rules.max, rules.phoneNumberValidate]"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="border-dashed-2 pt-3 px-2">
          <v-form v-model="passwordValid">
            <v-checkbox
              label="パスワードの変更"
              v-model="passwordCheck"
            ></v-checkbox>
            <v-text-field
              outline
              solo
              type="password"
              label="現在のパスワードを入力してください。"
              :disabled="!passwordCheck"
              v-model="agentInfo.password"
              required
            ></v-text-field>
            <v-text-field
              outline
              solo
              type="password"
              label="新しいパスワードを入力してください。"
              :disabled="!passwordCheck"
              v-model="agentInfo.newPassword"
              :rules="[rules.required, rules.passwordValidate]"
              :hide-details="!passwordCheck"
              :style="hideDetails()"
              required
            ></v-text-field>
            <v-text-field
              outline
              solo
              type="password"
              label="新しいパスワードを再入力してください。"
              :disabled="!passwordCheck"
              v-model="agentInfo.retryNewPassword"
              :rules="[rules.required, rules.passwordValidate, passwordMatch]"
              :hide-details="!passwordCheck"
              :style="hideDetails()"
              required
            ></v-text-field>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="border" flat @click.native="close">閉じる</v-btn>
      <v-btn class="registration" flat @click.native="checkChangeable" :disabled="!(valid && passwordValid)">変更</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import eventBus from '@/event_bus'

export default {
  name: 'user_info',
  props: ['controlStatus'],
  computed: {
    passwordMatch () {
      return v => this.$data.agentInfo.newPassword === v || 'パスワードが一致しません。'
    }
  },
  data () {
    return {
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || '6文字以上で入力してください。',
        passwordValidate: v => /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/g.test(v) || '半角英数字と特殊文字を組み合わせた8文字以上15文字以下',
        emailRules: v => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/g.test(v) || 'メールアドレス形式が異なります',
        phoneNumberValidate: v => /^[0-9]+$/g.test(v) || '数字のみ入力できます。',
        max: v => v.length <= 13 || '最大13桁まで入力できます',
        nameLength: v => v.length <= 20 || '最大20桁まで入力できます'
      },
      agentInfo: {
        name: '',
        loginId: '',
        phoneNumber: '',
        email: '',
        password: '',
        newPassword: '',
        retryNewPassword: '',
        passwordChangeCheck: false
      },
      valid: true,
      passwordValid: true,
      passwordCheck: false
    }
  },
  watch: {
    controlStatus (newStatus) {
      if (newStatus) {
        this.loadAgentInfo()
        this.initializeForm()
      } else {
        this.initializeForm()
      }
    },
    passwordCheck (newCheck) {
      if (!newCheck) {
        this.agentInfo.password = ''
        this.agentInfo.newPassword = ''
        this.agentInfo.retryNewPassword = ''
        this.passwordValid = true
      } else {
        this.passwordValid = false
      }
    }
  },
  methods: {
    initializeForm () {
      this.agentInfo = {
        name: '',
        phoneNumber: '',
        email: '',
        password: '',
        newPassword: '',
        retryNewPassword: '',
        passwordChangeCheck: false
      }
      this.valid = true
      this.passwordValid = true
      this.passwordCheck = false
    },
    loadAgentInfo () {
      this.axios.get('/api/agent/edit')
        .then(res => {
          if (res.status !== 200 || res.data.code !== 0) {
            this.$alertMsg(res.data.message || res.statusText)
            return
          }
          const info = res.data.data
          this.agentInfo.name = info.name
          this.agentInfo.email = info.email
          this.agentInfo.phoneNumber = info.phoneNumber
          this.agentInfo.loginId = info.loginId
        })
    },
    close () {
      eventBus.$emit('user-info-dialog-close')
    },
    checkChangeable () {
      this.agentInfo.passwordChangeCheck = this.passwordCheck
      if (this.passwordCheck) {
        if (this.agentInfo.password && this.agentInfo.newPassword && this.agentInfo.retryNewPassword) {
          this.changeInfo()
        } else {
          this.$alertMsg('未入力の欄があります。 確認してください。')
        }
      } else {
        this.changeInfo()
      }
    },
    changeInfo () {
      this.axios.post('/api/agent/edit', this.agentInfo)
        .then(res => {
          if (res.status !== 200 || res.data.code !== 0) {
            this.$alertMsg(res.data.message || res.statusText)
            return
          }
          this.$alertMsg('情報が変更されました。')
          this.close()
        })
    },
    hideDetails () {
      return !this.passwordCheck ? 'margin-bottom: 22px' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/header/fragments/user_info.vue